import { Box, Container, HStack, Stack } from '@chakra-ui/react'
import * as React from 'react'
import { IStep, Step } from './Step'

export interface IStepsWithAccent {
    steps: IStep[];
    currentStep: number;
    setStep: React.Dispatch<React.SetStateAction<number>>;
}

export const StepsWithAccent = (props: IStepsWithAccent) => {
  const { currentStep, setStep, steps } = props;
  return (
    <Box bg="bg-surface">
      <Container py={'2'} px={'4'}>
        <HStack spacing="4">
          {steps.map((step, id) => (
            <Step
              key={id}
              cursor="pointer"
              onClick={() => setStep(id)}
              title={step.title}
              description={step.description}
              isActive={currentStep === id}
              isCompleted={currentStep > id}
            />
          ))}
        </HStack>
      </Container>
    </Box>
  )
}
